import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";

class RoomDevTestApi extends BaseApi {
    constructor() {
        super()
        Room.DevTest = this;

        if(process.env.NODE_ENV === 'production') {
            return;
        }

        Room.ready(async e => {
            this._eventListen(this.Events);
        });
    }

    command (api, data) {
        this.commandToUsers(api, data);
    }
    commandToUsers (api, data, userIds) {
        const text = 'devtest:'+JSON.stringify({
            api,
            data
        });
        const msg = {text};
        if(userIds){
            if(typeof userIds === 'string'){
                userIds = [userIds];
            }
            Object.assign(msg, {
                target: 'user',
                toUserIds: userIds
            });
        }
        Room.Chat.sendChatMessage(msg);
    }

    parseTextData (e) {
        let {text} = e.data;
        if(!text) return;
        const token = 'devtest:';
        if(!text.startsWith(token)) return;
        text = text.substring(token.length);

        let msg = (() => {
            try{
                return JSON.parse(text);
            }catch(e){
                return {api: text}
            }
        })();
        console.log('# on dev test data:', text, msg);

        let func = this.DevApi[msg.api];
        if(func){
            func.call(this, msg, e);
        }
    }

    Events = {
        room_chat_text: async function (e) {
            this.parseTextData(e);
        }
    }

    DevApi = {
        ping (msg, e) {
            // eventTime, userId
            let received = Date.now() - new Date(e.eventTime).getTime();
            this.commandToUsers('pong', {
                received
            }, e.userId)
        },
        pong (msg, e) {
            let {eventTime, userId} = e;
            let ru = Room.User.getRoomUser(userId);
            let received = Date.now() - new Date(eventTime).getTime();
            console.log('# receive pong: user[%s], sendTerm[%sms], receiveTerm[%sms]',
                ru?.nickname + ',' + userId,
                msg.data.received,
                received
            );
        },
        reloadAllUser (msg, e) {
            const {data} = msg;
            let {sec, addSec, dm} = data;

            ((seconds, addSec, dm) => {
                const now = new Date();
                let ns = now.getSeconds();
                while(ns >= seconds){
                    seconds += addSec || 10;
                }

                const time = new Date(Date.now() + ((seconds-ns)*1000)).setMilliseconds(0);
                let term = time - Date.now();
                if(dm && dm > 0){
                    // dm 초 이내의 랜덤값.
                    term += Math.random() * (1000 * dm);
                }
                setTimeout(() => {
                    console.log('실행:', new Date().toLocaleString())
                    location.reload();
                }, term)
                console.log('%s ms후 %s에 전체 reload.', term, new Date(time).toLocaleString())
            })(sec || 10, addSec || 10, dm);
        },
    }
}

export const RoomDevTest = new RoomDevTestApi();
